import { ReactNode } from 'react';

import { cx } from '@/ui/cva';

export type GridRevealBlockButtonProps = {
    isActive: boolean;
    children: ReactNode;
    onClick: () => void;
};

export function GridRevealBlockButton({
    isActive = false,
    children,
    onClick,
}: GridRevealBlockButtonProps) {
    return (
        <button
            onClick={onClick}
            type="button"
            className={cx(
                'relative overflow-hidden rounded-xl bg-gray p-xs text-center text-xl font-bold text-white outline-none transition',
                'sm:p-sm sm:text-4xl',
                'before:absolute before:inset-0 before:bg-gradient-to-r before:from-[--gradient-start] before:to-[--gradient-end] before:opacity-0 before:transition',
                isActive && 'before:opacity-100',
                'hover:scale-105',
                'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue',
                'active:scale-95 active:outline-none'
            )}
        >
            <span className="relative">{children}</span>
        </button>
    );
}
